import Api from "../baseApi";

const state = {
  all: [],
  detail: {},
  country: [],
  countrySales: {},
  countrySalesList: {},
  city: [],
  dailySales: [],
  platformTotalSales: [],
  platformTotalSalesQuery: [],
  citySelect: { id: "0", value: "All" },
  countrySelect: { id: "0", value: "All" },
  dynamicOfferSelect: { name: "All", id: null },
  productTypeSelect: { value: null, id: "All" },
  stateSelect: { id: "", value: "All" },
  priceSelect: { id: -1, value: "All" },
  platformSelect: { id: "", value: "All" },
};
const getters = {
  setting: (state) => {
    return state.setting;
  },
};
const actions = {
  getAll: async (context, params) => {
    //eslint-disable-next-line no-console
    if (!params.endDate) params.endDate = params.startDate;
    let url = `/product/purchases?startDate=${params.startDate}&state=${state.stateSelect.id}&endDate=${params.endDate}&q=${params.search}&p=${params.page}&t=${params.size}`;
    if (state.citySelect.id != "0") url += `&city=${state.citySelect.id}`;
    if (state.countrySelect.id != "0")
      url += `&country=${state.countrySelect.id}`;

    if (state.priceSelect.id > -1) url += `&price=${state.priceSelect.id}`;
    if (state.productTypeSelect.value != null)
      url += `&productType=${state.productTypeSelect.value}`;
    if (state.dynamicOfferSelect.id != null)
      url += `&offerId=${state.dynamicOfferSelect.id}`;
    if (state.platformSelect.id != "")
      url += `&platform=${state.platformSelect.id}`;
    if (params.options.sortBy[0])
      url += `&sortBy=${params.options.sortBy[0]}&sortDesc=${params.options.sortDesc[0]}`;
    let d = (await Api.get(url)).data;
    context.commit("getAll", d);

    return d;
  },
  getPlatformTotalSalesQuery: async (context, params) => {
    //eslint-disable-next-line no-console
    if (!params.endDate) params.endDate = params.startDate;
    let url = `/product/purchases/GetPlatformTotalSalesQuery?startDate=${params.startDate}&endDate=${params.endDate}&state=${state.stateSelect.id}&q=${params.search}`;
    if (state.citySelect.id != "0") url += `&city=${state.citySelect.id}`;
    if (state.countrySelect.id != "0")
      url += `&country=${state.countrySelect.id}`;
    if (state.priceSelect.id > -1) url += `&price=${state.priceSelect.id}`;
    if (state.productTypeSelect.value != null)
      url += `&productType=${state.productTypeSelect.value}`;
    if (state.platformSelect.id != "")
      url += `&platform=${state.platformSelect.id}`;
    let d = (await Api.get(url)).data;
    context.commit("getPlatformTotalSalesQuery", d);

    return d;
  },
  getByDailySales: async (context, params) => {
    let url = `/product/purchases/GetByDailySales/${params.startDate}/${params.endDate}`;
    let d = (await Api.get(url)).data;
    context.commit("getByDailySales", d);
  },
  getPlatformTotalSales: async (context, params) => {
    let url = `/product/purchases/GetPlatformTotalSales`;
    if (params)
      url += `?startDate=${params.startDate}&endDate=${params.endDate}`;

    let d = (await Api.get(url)).data;
    context.commit("getPlatformTotalSales", d);
    return d;
  },
  getByCountrySales: async (context, state) => {
    let url = `/product/purchases/GetByCountrySales/${state}`;
    let d = (await Api.get(url)).data;
    context.commit("getByCountrySales", d);
    return d;
  },

  getRefundCheck: async () => {
    await Api.get(`/management/RefundProducts/Check/5`);
  },
  getCountry: async (context) => {
    let d = (await Api.get(`/product/purchases/country`)).data;
    context.commit("getCountry", d);
  },
  getCity: async (context) => {
    let d = (await Api.get(`/product/purchases/city`)).data;
    context.commit("getCity", d);
  },
  get: async (context, id) => {
    context.commit("get", id);
  },
};
const mutations = {
  getPlatformTotalSales(state, settings) {
    state.platformTotalSales = settings;
  },
  getByCountrySales(state, settings) {
    state.countrySalesList = settings;
    settings.forEach((element) => {
      state.countrySales[(element.countryCode || "").toUpperCase()] =
        element.total;
    });
  },
  getPlatformTotalSalesQuery(state, settings) {
    state.platformTotalSalesQuery = settings;
  },

  getByDailySales(state, settings) {
    state.dailySales = settings;
  },
  getAll(state, settings) {
    state.all = settings;
  },
  getCountry(state, country) {
    state.country = [{ id: "0", value: "All" }, ...country];
  },
  getCity(state, city) {
    state.city = [{ id: "0", value: "All" }, ...city];
  },
  get(state, id) {
    state.detail = state.all.data.find((m) => m.id == id);
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
